import { render, staticRenderFns } from "./pelvisRisk.vue?vue&type=template&id=487258b1&scoped=true&"
import script from "./pelvisRisk.vue?vue&type=script&lang=js&"
export * from "./pelvisRisk.vue?vue&type=script&lang=js&"
import style0 from "./pelvisRisk.vue?vue&type=style&index=0&id=487258b1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487258b1",
  null
  
)

export default component.exports